import { useNavigationContext } from '../../../contexts/NavigationContext';
import ShowPage from './show/ShowPage';
import MainLayout from '../../../components/Display/MainLayout';

function Home() {
  const { navigationContext } = useNavigationContext();
  return (

    <MainLayout scope={'nouvelleparenthese'} websiteLabel={"lanouvelleparenthese.fr"}>
      {<ShowPage isActive={navigationContext.activeAppKey === 'show'} />}
    </MainLayout>
  );
}

export default Home;
